<div class="grid-item" [ngClass]="{'on-preview': displayed}">
    <div class="grid-item-details">
        <!-- Floating header with three dots menu -->
        <div class="floating-header">
            <core-helpers-navigation-three-dots-menu 
                [menu]="menu"
                (action)="onMenuSelect($event)">
            </core-helpers-navigation-three-dots-menu>
        </div>
        <div class="grid-item-content">
            <!-- Preview image area -->
            <div class="item-preview" [title]="file?.name" (click)="onActionClick($event)">
                <!-- Loading state - only show when actively loading, never with errors -->
                <div *ngIf="isLoading" class="preview-loading">
                    <div class="loader">
                        <div class="dimmed">
                            <div class="dimmed_box"></div>
                        </div>
                    </div>
                </div>

                <!-- Error state - only show when there's an error and not loading -->
                <div *ngIf="errorMessage && !isLoading" class="preview-error">
                    <core-helpers-box-alert-message-icon 
                        [text]="'No preview available'"
                        [icon]="'alert'">
                    </core-helpers-box-alert-message-icon>

                </div>

                <!-- Preview content with pages -->
                <div *ngIf="!isLoading && !errorMessage && totalPages > 0" class="preview-content">
                    <!-- Preview pages container -->
                    <div class="preview-pages">
                        <ng-container *ngFor="let page of previewPages">
                            <!-- Only render pages that should be preloaded or are visible -->
                            <div 
                                *ngIf="shouldPreloadPage(page.position)" 
                                class="preview-page-wrapper"
                                [hidden]="!isPageVisible(page.position)">
                                <core-storage-page-preview 
                                    [presignedUrl]="page.image.url"
                                    [pageNumber]="page.position"
                                    [fileId]="file.uuid"
                                    (onLoad)="onStoragePageLoad(page.position)"
                                    (onError)="onStoragePageError(page.position, $event)">
                                </core-storage-page-preview>
                            </div>
                        </ng-container>
                    </div>

                    <!-- @deprecated Pagination removed from grid view (2026-06-17)
                         Users can click on the file to open full-page preview for multi-page navigation.
                         Navigation code kept for future use if pagination is re-enabled.
                    -->
                    <!-- LEFT ICON FOR PAGE NAVIGATION -->
                    <!-- <div class="left-icon" 
                        title="Previous page" 
                        (click)="previousPage($event)"
                        [hidden]="totalPages <= 1" 
                        [ngClass]="{'disabled': currentPage == 1}">
                    </div> -->
                
                    <!-- RIGHT ICON FOR PAGE NAVIGATION -->
                    <!-- <div class="right-icon"  
                        title="Next page" 
                        (click)="nextPage($event)"
                        [hidden]="totalPages <= 1"  
                        [ngClass]="{'disabled': currentPage == totalPages}">
                    </div> -->

                    <!-- PAGE COUNTER - Shows page info when file has multiple pages -->
                    <span class="page-counter" *ngIf="totalPages > 1">{{ getPageInfo() }}</span>
                </div>

                <!-- Empty state -->
                <div *ngIf="!isLoading && !errorMessage && totalPages === 0" class="preview-empty">
                    <p>No preview pages available</p>
                </div>
            </div>

            <!-- File metadata section -->
            <span class="title" [title]="file?.name" (click)="onActionClick($event)">
                {{ file?.name }}
            </span>

            <!-- Size, extension, notes counter, and download -->
            <div class="size-bubble">
                <span class="ext">{{ getFileExtension(file?.name) }}</span>
                <span class="size"> ({{ humanFileSize(file?.size) }})</span>
                
                <!-- Notes counter bubble -->
                <core-helpers-icons-notes-counter-bubble 
                    *ngIf="notes != 0 && notes != null" 
                    [title]="notes + ' notes'"
                    [letter]="notes" 
                    (actionClick)="onActionClick($event)">
                </core-helpers-icons-notes-counter-bubble>
                
                <!-- Download icon -->
                <span class="download-icon" 
                    title="Download" 
                    (click)="onActionDownloadClick($event)">
                </span>
            </div>
        </div>
    </div>
</div>
